export const mutationKeys = {
  // Accounts
  createAccount: 'createAccount',
  updateAccount: 'updateAccount',

  // Events
  createEvent: 'createEvent',
  updateEvent: 'updateEvent',
  duplicateEvent: 'duplicateEvent',

  // Tasks
  createTask: 'createTask',
  updateTask: 'updateTask',

  // Contacts
  createContact: 'createContact',
  updateContact: 'updateContact',

  // Employees
  createEmployee: 'createEmployee',
  updateEmployee: 'updateEmployee',

  // Task Templates
  createTaskTemplate: 'createTaskTemplate',
  updateTaskTemplate: 'updateTaskTemplate',

  // Account Templates
  createAccountTemplate: 'createAccountTemplate',
  updateAccountTemplate: 'updateAccountTemplate',

  // Contact Templates
  createContactTemplate: 'createContactTemplate',
  updateContactTemplate: 'updateContactTemplate',

  // Employee Templates
  createEmployeeTemplate: 'createEmployeeTemplate',
  updateEmployeeTemplate: 'updateEmployeeTemplate',

  // Form Templates
  createFormTemplate: 'createFormTemplate',
  updateFormTemplate: 'updateFormTemplate',

  // Event Templates
  createEventTemplate: 'createEventTemplate',
  updateEventTemplate: 'updateEventTemplate',

  // Email Templates
  createEmailTemplate: 'createEmailTemplate',
  updateEmailTemplate: 'updateEmailTemplate',
  sendEmails: 'sendEmails',

  // User Permissions
  createUserRole: 'createUserRole',
  updateUserRole: 'updateUserRole',

  // Organization
  updateOrganization: 'updateOrganization',

  // Form Submissions
  createFormSubmission: 'createFormSubmission',
  updateFormSubmission: 'updateFormSubmission',
};
